import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';

const SubirDocumento = () => {
  const location = useLocation();
  const protocoloGeneral = location.state?.protocoloGeneral;
  const successMessage = location.state?.successMessage || '';
  const navigate = useNavigate();

  useEffect(() => {
    if (!successMessage) {
      return;
    }

    toast.success(successMessage);
  }, [successMessage]);

  const handleContinue = () => {
    if (!protocoloGeneral) {
      toast.error('No se encontro el protocolo general del caso.');
      return;
    }

    navigate('/ingreso-muestra', { state: { protocoloGeneral } });
  };

  return (
    <section className="container page-shell">
      <div className="page-header">
        <div>
          <span className="section-kicker">Documentacion</span>
          <h2 className="page-title">Carga de documentos pausada</h2>
          <p className="page-subtitle">
            La carga de archivos del caso <strong>{protocoloGeneral || 'sin protocolo'}</strong> esta temporalmente inhabilitada.
          </p>
        </div>
        <img src="/logo-inta.png" alt="Logo INTA" className="page-header-logo" />
      </div>

      <div className="surface-card">
        {successMessage ? (
          <div className="alert alert-success mb-4" role="status">
            {successMessage}
          </div>
        ) : null}

        <div className="alert subtle-alert subtle-alert--info mb-4" role="status">
          Por ahora solo queda habilitada la carga de archivos en resultados diagnosticos.
        </div>

        <div className="d-flex justify-content-end">
          <button type="button" className="btn btn-brand" onClick={handleContinue}>
            Continuar a muestras
          </button>
        </div>
      </div>
    </section>
  );
};

export default SubirDocumento;
